import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLiff } from "react-liff";

// import VConsole from "vconsole";

import MainLayout from "./layouts/MainLayout";
import PageLoader from "./components/loader/PageLoader";

import AppRouter from "./appRouter"; // Router

import { setProfile } from "./features/ProfileSlice";

import { AccessToken } from "./services/Api/Module/Customer";

const devMode = false;

function App() {
  const dispatch = useDispatch(); // ไว้อัพเดต state กลาง
  const stateProfile = useSelector((state) => state.profile);

  const [isLoadedProfile, setIsLoadedProfile] = useState(false);
  const [isHasProfile, setIsHasProfile] = useState(false);

  let { isLoggedIn, liff } = useLiff();

  if (!isLoggedIn && devMode) {
    isLoggedIn = devMode; // mock true เอาไว้ dev
  }

  const initialized = useRef(false);

  useEffect(() => {
    // console.log("isLoggedIn >>", isLoggedIn);

    if (isLoggedIn && !initialized.current) {
      initialized.current = true;

      (async () => {
        try {
          const profile = await liff.getProfile();

          if (profile) {
            const sub = liff.getDecodedIDToken().sub;
            // console.log(profile, sub);

            let tmpObj = {
              lineUid: sub,
            };
            // console.log(tmpObj);

            genAccessToken({
              lineUid: sub,
            }).then((_rsData) => {
              // console.log(
              //   "_rsData >>",
              //   _rsData,
              //   _rsData.result?.id !== undefined
              // );

              if (_rsData.status === true) {
                // console.log(_rsData.result, sub);

                if (
                  typeof _rsData.result.token !== "undefined"
                ) {
                  window.localStorage.setItem("token", _rsData.result.token);

                  setIsHasProfile(true);
                }

                dispatch(setProfile(tmpObj));

                setIsLoadedProfile(true);
              }
            });
          }
        } catch (error) {
          // console.warn(error);
        }
      })();
    }
  }, [isLoggedIn]);

  // useEffect(() => {
  //   console.log("isLoadedProfile >>", isLoadedProfile, isHasProfile);
  //   // if (isLoadedProfile) {
  //   //   const vConsole = new VConsole();
  //   // }
  // }, [isLoadedProfile, isHasProfile]);

  const genAccessToken = async (payload) => {
    let _return = {
      status: false,
      result: null,
    };

    try {
      const { data } = await AccessToken({ lineUid: payload.lineUid });
      if (data.resultCode === 20200) {
        const resData = data.body;
        // console.log("genAccessToken resData >>", resData);

        _return.status = true;
        _return.result = resData;
      }
    } catch (e) {
      console.log("ERR genAccessToken >> ", e);
    }

    return _return;
  };

  return (
    <>
      {isLoadedProfile ? (
        <MainLayout>
          <AppRouter isHasProfile={isHasProfile} profileData={stateProfile} />
        </MainLayout>
      ) : (
        <>
          <PageLoader />
        </>
      )}
    </>
  );
}

export default App;
